// iPhone / Android lock-screen safe zones, per device.
// Format: each zone is [xMin, xMax, yMin, yMax] in pixel coordinates of the canvas.

export type SafeZone = [number, number, number, number];
export type DeviceProfile = {
  id: string;
  label: string;
  w: number;
  h: number;
  zones: Record<string, SafeZone>;
};

export const DEVICES: DeviceProfile[] = [
  {
    id: "iphone17pm",
    label: "iPhone 17 Pro Max",
    w: 1320,
    h: 2868,
    zones: {
      statusBar: [0, 1320, 0, 80],
      dateStrip: [300, 1020, 170, 230],
      clock:     [200, 1120, 240, 540],
      flashlight:[60, 180, 2620, 2740],
      camera:    [1140, 1260, 2620, 2740],
      homeIndicator: [560, 760, 2820, 2860],
    },
  },
  {
    id: "iphone17p",
    label: "iPhone 17 / 16 Pro",
    w: 1206,
    h: 2622,
    zones: {
      statusBar: [0, 1206, 0, 75],
      dateStrip: [275, 935, 155, 215],
      clock:     [185, 1020, 220, 495],
      flashlight:[55, 165, 2395, 2510],
      camera:    [1040, 1150, 2395, 2510],
      homeIndicator: [515, 690, 2580, 2615],
    },
  },
  {
    id: "iphone16",
    label: "iPhone 16 / 15",
    w: 1179,
    h: 2556,
    zones: {
      statusBar: [0, 1179, 0, 70],
      dateStrip: [270, 910, 150, 205],
      clock:     [180, 1000, 215, 480],
      flashlight:[55, 160, 2335, 2450],
      camera:    [1020, 1125, 2335, 2450],
      homeIndicator: [505, 675, 2515, 2545],
    },
  },
  {
    id: "pixel9pro",
    label: "Pixel 9 Pro",
    w: 1280,
    h: 2856,
    zones: {
      statusBar: [0, 1280, 0, 80],
      dateStrip: [290, 990, 165, 220],
      clock:     [195, 1085, 235, 525],
      // Pixel 9 typically doesn't show flashlight/camera shortcuts.
      homeIndicator: [540, 740, 2810, 2850],
    },
  },
  {
    id: "generic1080",
    label: "Generic 1080×2400",
    w: 1080,
    h: 2400,
    zones: {
      statusBar: [0, 1080, 0, 65],
      dateStrip: [240, 840, 140, 195],
      clock:     [165, 915, 210, 460],
      homeIndicator: [450, 630, 2360, 2390],
    },
  },
];

export const DEFAULT_DEVICE = DEVICES[0];

export function getDevice(id: string): DeviceProfile {
  return DEVICES.find(d => d.id === id) ?? DEFAULT_DEVICE;
}
